import { useState, useEffect } from 'react';
import './App.css';
import Filters from './components/Filters';
import ProductList from './components/ProductList';
import WineDetail from './components/WineDetail';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import wineData from './data/wineData';
import { grapeVarietyFilterApplier } from './filters/grapeVarieties';

function AppContent() {
  const initState = {
    type: 'all',
    size: 'all',
    producer: 'all',
    region: 'all',
    year: 'all',
    priceRange: 'all',
    grapes: [],
  };
  const [filters, setFilters] = useState(initState);

  // const [selectedWine, setSelectedWine] = useState(null);
  const { language, toggleLanguage } = useLanguage();
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const filteredWines = wineData.filter(wine => {
    return (filters.name === undefined || wine.name.toLowerCase().includes(filters.name.toLowerCase())) &&
           (filters.type === 'all' || wine.type.value === filters.type) &&
           (filters.size === 'all' || wine.size.value === filters.size) &&
           (filters.producer === 'all' || wine.producer.value === filters.producer)&&
           (filters.region === 'all' || wine.region.value === filters.region) &&
           (filters.year === 'all' || wine.year === filters.year) && 
           (filters.priceRange === 'all' || wine.priceRange.value === filters.priceRange) && 
           (grapeVarietyFilterApplier(filters, wine));
  });
  const selectedWine = selectedIndex !== null ? filteredWines[selectedIndex] : null;

  useEffect(() => {
    if (selectedIndex === null) return; // no popup open

    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        setSelectedIndex((prevIndex) => {
          // wrap-around to start if at end
          return (prevIndex + 1) % filteredWines.length;
        });
      } else if (e.key === "ArrowLeft") {
        setSelectedIndex((prevIndex) => {
          return (prevIndex - 1 + filteredWines.length) % filteredWines.length;
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex, filteredWines.length]);

  const applyFilter = (filterType, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterType]: value
    }));
  };


  const handleWineClick = (wine) => {
    setSelectedIndex(filteredWines.indexOf(wine));
  };

  const handleClosePopup = () => {
    setSelectedIndex(null);
  };

  const prevWine = () => {
    setSelectedIndex((i) => (i - 1 + filteredWines.length) % filteredWines.length);
  };

  const nextWine = () => {
    setSelectedIndex((i) => (i + 1) % filteredWines.length);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>{language === 'en' ? 'VIANPE Wine Catalog' : 'Catálogo de Vinhos VIANPE'}</h1>
        <button onClick={toggleLanguage} className="language-toggle">
          {language === 'en' ? 'PT' : 'EN'}
        </button>
      </header>
      <div className="content">
        <aside className={`sidebar ${isSidebarExpanded ? 'expanded' : 'minimized'}`}>
          <Filters 
            applyFilter={applyFilter} 
            currentFilters={filters}
            filteredWines={filteredWines}
            resetFilters={() => setFilters(initState)}
            onToggle={() => setIsSidebarExpanded(!isSidebarExpanded)}
          />
        </aside>
        <main className={isSidebarExpanded ? '' : 'sidebar-minimized'}>
          <ProductList wines={filteredWines} onWineClick={handleWineClick} />
        </main>
      </div>
      {selectedWine && (
        <div className="popup-overlay" onClick={handleClosePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="wine-detail-with-arrows">
              <button className="arrow arrow-left" onClick={prevWine}>&#10094;</button>
              <WineDetail wine={selectedWine} onClose={handleClosePopup} />
              <button className="arrow arrow-right" onClick={nextWine}>&#10095;</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
